import { Component, ChangeDetectionStrategy, Input } from "@angular/core";
import { environment } from "@env";
import { IUserProfile } from "@shared/interfaces/user/user-profile";
import { ApiService } from "@shared/services/api.service";
import { StorageService } from "@shared/services/storage.service";
import { UserService } from "@shared/modules/account/services/user.service";
import { WindowService } from "@shared/services/window.service";
import { ModalService } from "@shared/services/modal.service";


@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContextMenuComponent {
  @Input() currentUser!: IUserProfile;
  @Input() baseAvatarUrl: string = "";

  constructor(
    private userService: UserService,
    private storage: StorageService,
    private api: ApiService,
    private windowService: WindowService,
    private modalService: ModalService) { }

  logout() {
    this.userService.logout();
  }
  
  redirectToPrivacyPolicy(): void {
    this.windowService.blankOpen(environment.privacyPolicy.url);
  }

  openTerms() {
    const idLanguage = JSON.parse(this.storage.getStorage(this.storage.idLanguage));
    const lpLanguage = JSON.parse(this.storage.getStorage(this.storage.lpLanguage));
    const language = idLanguage ? idLanguage : lpLanguage;
    this.windowService.blankOpen(`${this.api.url}terms-of-service-en.pdf`);
  }
  
  onTwoFactorSetup(){
    this.modalService.showTwoFactorConfigurationModal();
  }

  trackByFn(index: number, item: any) {
    return item;
  }
}
